import { Col, Row } from '@geberit/gdds';

// styles
import styles from './image-gallery.module.scss';

// types
import type { WrapperProps } from '../types';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';

export function Wrapper({
  children,
  imageGallery,
  itemsPerRow,
  withHeadline,
}: Readonly<WrapperProps>) {
  const centeredClassName = imageGallery?.length === 3 && styles.centerRow;

  return (
    <Row className={classNameBuilder(centeredClassName, withHeadline && styles.negativeMargin)}>
      <Col size={[4, 8, 12]}>
        <div
          className={classNameBuilder(
            styles.itemsWrapper,
            itemsPerRow === '4' ? styles.fourItemsPerRow : styles.threeItemsPerRow,
          )}
        >
          {children}
        </div>
      </Col>
    </Row>
  );
}
